export default __webpack_public_path__ + "static/media/zone-delete.278ed9d8.svg";